import fuzzysort from "fuzzysort";

import { RepoFile } from "types/generated";

const SCORE_THRESHOLD = -10000;

const filterCommitFiles = (files: RepoFile[], query: string): RepoFile[] => {
  if (!query) {
    return files;
  }

  const results = fuzzysort.go(query, files, {
    key: "filePath",
    threshold: SCORE_THRESHOLD,
  });

  return results.map((result) => result.obj);
};

export default filterCommitFiles;
